import axios from 'axios'

export default {
    namespaced: true,
    state: {
        states: [],
        status_array: [],
        roles: [],
        measurement_types: [],
        cleaners: [],
        chemicals: [],
        renewals: [],
        customers: []
    },
    getters: {
        customers (state) {
            return state.customers
        },
        states (state) {
            return state.states
        },
        statusArray (state) {
            return state.status_array
        },
        roles (state) {
            return state.roles
        },
        measurement_types (state) {
            return state.measurement_types
        },
        cleaners (state) {
            return state.cleaners
        },
        chemicals (state) {
            return state.chemicals
        },
        renewals (state) {
            return state.renewals
        }
    },
    mutations: {
        SET_CUSTOMERS(state, payload) {
            state.customers = payload
        },
        SET_STATES(state, payload) {
            state.states = payload
        },
        SET_STATUS_ARR(state, payload) {
            return state.status_array = payload
        },
        SET_ROLES(state, payload) {
            return state.roles = payload
        },
        SET_MEASUREMENT_TYPES(state, payload) {
            return state.measurement_types = payload
        },
        SET_CLEANERS(state, payload) {
            return state.cleaners = payload
        },
        SET_CHEMICALS(state, payload) {
            return state.chemicals = payload
        },
        SET_RENEWALS(state, payload) {
            return state.renewals = payload
        }
    },
    actions: {
        async getData({ commit }) {
            let response = await axios.post('cleaners/data')
            commit('SET_STATES', response.data.data.states)     
            commit('SET_STATUS_ARR', response.data.data.status_array)
            commit('SET_ROLES', response.data.data.roles)
            commit('SET_MEASUREMENT_TYPES', response.data.data.measurement_types)
            commit('SET_CLEANERS', response.data.data.cleaners)
            commit('SET_CHEMICALS', response.data.data.chemicals)
            commit('SET_RENEWALS', response.data.data.renew)
        },
        async addCustomer( { dispatch }, data) {
            let response = await axios.post('cleaners/addcustomer', data)
            await dispatch('getData')
            return response.data
        },
        async updateCustomer( { dispatch }, data) {
            let response = await axios.post('cleaners/updatecustomer', data)
            await dispatch('getData')
            return response.data
        },
        async addComment(_, data) {
            let response = await axios.post('cleaners/comment', data)        
            return response.data
        },
        async updateUser( { dispatch }, data) {
            let response = await axios.post('cleaners/updateuser', data)
            await dispatch('getData')
            return response.data
        },
        async addJob( { dispatch }, data) {
            let response = await axios.post('cleaners/addjob', data)
            await dispatch('getData')
            return response.data
        },
        async updateJob( { dispatch }, data) {
            let response = await axios.post('cleaners/updatejob', data)
            await dispatch('getData')
            return response.data
        },
        async completeJob( { dispatch }, data) {
            let response = await axios.post('cleaners/completejob', data)
            await dispatch('getData')
            return response.data
        },
    }
}